<mat-label *ngIf="form.controls.activity.value > 0" class="mx-1 my-2 p-2" style="margin-bottom: 10px; font-weight: bold;">
    Validity Check Questions
</mat-label>
<div class="p-2 mb-3 mt-3"  *ngIf="form.controls.activity.value > 0">
    <div class="activity mb-3">
        <b class="my-3 mx-2" style="margin-bottom: 10px;">Activity:</b> {{activity.activityType}}
        <div class="condition m-2" *ngFor="let condition of activity.conditions; let j = index">

            <div class="" *ngIf="condition.conditionType.toUpperCase() == 'BOOLEAN'">
                <div class="condition-question ">{{condition.conditionName}} *</div>
                <mat-radio-group
                        required
                        [disabled]="uploading"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="activity.conditions[j].answer"
                        style="margin-left: -10px;">
                    <mat-radio-button [value]="'true'">Yes</mat-radio-button>
                    <mat-radio-button [value]="'false'">No</mat-radio-button>
                </mat-radio-group>

            </div>
            <div class="" *ngIf="condition.conditionType.toUpperCase() == 'INTEGER'">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>{{condition.conditionName}}</mat-label>
                    <input [disabled]="uploading" [ngModelOptions]="{standalone: true}"
                            required
                            [(ngModel)]="activity.conditions[j].answer"
                            class="text-end"
                            type="number"
                            matInput>
                </mat-form-field>

            </div>

        </div>
        <div class="mx-2 pt-3" style="border-top: 1px solid #ccc;">
            <b class="mt-3 mb-3" style="margin-bottom: 10px;">Activity Completion Question</b>
            <mat-form-field class="w-100 mt-3" appearance="outline">
                <mat-label>{{activity.completionQuestion}}</mat-label>
                <input [disabled]="uploading"
                        required
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="activity.completionQuestionAnswer"
                        class="text-end"
                        type="number"
                        matInput>
                <span matSuffix class="mx-2">{{activity.unitBase}}</span>
            </mat-form-field>

        </div>
        <hr />
    </div>

    <div *ngIf="summary" class="dark-bg mb-2 pb-2 " >
        <b class="mt-3" style="margin-bottom: 10px;">Summary</b>
        <div class="condition-question mt-2">
            {{summary}}
        </div>

    </div>
    <div class="condition-question pb-2 mb-2 mt-2">
        <button type="button" [disabled]="uploading" mat-flat-button color="accent"  (click)="getSummary()">Get Summary</button>
    </div>
</div>
